import { useKernelApi } from 'infrastructure/api';
import { ResourceData } from 'framework/crud';

export enum AssignmentTargetType {
  PROJECT = 'PROJECT',
  SERVICE = 'SERVICE',
  SERVICE_CATALOG_SERVICE = 'SERVICE_CATALOG_SERVICE',
}

const useAssignmentTargetService = () => {
  const { sendPostRequest } = useKernelApi();

  const search = async (request: ResourceData) => {
    const response = await sendPostRequest('/resourceAssignments/targets', request);
    return response.json();
  };

  return {
    search,
  };
};

export default useAssignmentTargetService;
